export default {
  slug: "aqua",
  code: "AQ",
  label: "Aqua",
  logoFamily: "jb",
};
